import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


function CustomizedDialogs(props) {
  const { open, setOpen, setClose } = props;

  const handleClose = () => {
    setClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      scroll={"body"}
    >
        <IconButton style={{position: 'absolute', top: 0, right: 0}} onClick={() => setClose()}><CloseIcon style={{color: '#563a96'}} /></IconButton>
      <DialogContent>
        <div style={{ height: "400px", width: "500px", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          {/* <img src={comingSoonIcon} style={{height: '240px'}} /> */}
          <Typography
            style={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
              fontSize: "24px",
              color: "#000",
              textAlign: 'center'
            }}
          >
          Please update the details of your ongoing mentorship session. If there is no activity for 30 days, the mentorship session will be presumed complete
          </Typography>
          <Button
            style={{
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#563a96",
              borderRadius: '30px', 
              padding: '10px 25px', 
              marginTop: '20px'
            }}
            variant="contained"
            onClick={() => setClose()}
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CustomizedDialogs